<div class="modal-header">
    <h4 class="modal-title">
        {{ 'Create a new request link' | translate }}
    </h4>
    <button type="button" class="btn btn-icon btn-close btn-transparent" aria-label="Close" (click)="close()">
        <sb-inline-svg
            class="icon icon-close"
            aria-label="My icon"
            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'"></sb-inline-svg>
    </button>
</div>

@if (!request) {
    <div class="modal-body">
        <form id="requestForm" #requestForm="ngForm" name="requestForm" (ngSubmit)="createRequest()" ngNativeValidate>
            <div class="form-group">
                <label for="internalReference">
                    {{ 'Internal reference' | translate }}
                </label>
                <div class="position-relative">
                    <input
                        type="text"
                        class="form-control"
                        id="internalReference"
                        name="internalReference"
                        placeholder="{{ 'Internal reference' | translate }}"
                        [(ngModel)]="newRequest.internalReference"
                        required />
                </div>
            </div>
            <div class="form-group">
                <label for="notes">
                    {{ 'Notes' | translate }}
                </label>
                <textarea
                    [(ngModel)]="newRequest.requestedBy"
                    name="notes"
                    id="notes"
                    rows="3"
                    placeholder="{{ 'Notes' | translate }}"
                    class="form-control"
                    required></textarea>
            </div>
            <p class="font-italic">
                {{ 'The request link will live for' | translate }}
                {{ initializationService.portal.requestLinkLifeTimeInDays }} {{ 'days.' | translate }}
            </p>
        </form>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary" form="requestForm" [disabled]="isCreatingNewRequest">
            {{ 'Next' | translate }}
        </button>
    </div>
} @else {
    <div class="modal-body">
        <div class="text-center">
            <h2>
                {{ 'Good job!' | translate }}
            </h2>
            <textarea
                class="form-control top30 access-token-url"
                [(ngModel)]="request.accessToken.url"
                readonly></textarea>
            <button
                class="btn btn-info top10"
                ngxClipboard
                [cbContent]="request.accessToken.url"
                (click)="showClipboardNotification()">
                {{ 'Copy to clipboard' | translate }}
            </button>
        </div>
    </div>
    <div class="modal-footer justify-content-start">
        <div style="display: inline-block; margin-right: auto">
            {{ 'Send this link to your Access Request Subject' | translate }}
        </div>
        <button type="button" class="btn btn-secondary" (click)="close()">
            {{ 'Close' | translate }}
        </button>
    </div>
}
